module.exports = __webpack_public_path__ + "img/BEL.412d8c25.svg";